import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import articlePage from "@faire/web-api--source/routes/support/articles/articleId";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";

export const ReturnedToSenderIA: React.FC = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="If you’ve attempted to ship an order, and it’s been returned to you, it could be due to a number of different reasons. Review our <ArticleLinkFormatting>detailed guide</ArticleLinkFormatting> on <BoldFormatting>return to sender</BoldFormatting> issues to find recommended next steps, for both domestic or international shipments."
          description={{
            text: "A step-by-step guide to cannot find an order",
          }}
          values={{
            ArticleLinkFormatting,
            BoldFormatting,
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="For more assistance, please contact us. We're always here to help."
          description={{
            text: "A step-by-step guide to cannot find an order",
          }}
        />
      </Typography>
    </Column>
  );
};

const ArticleLinkFormatting = (chunks: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={articlePage("26594585812891")}
    target="_blank"
  >
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
